import { replaceStylesheetGlobals } from '../portal/theme/portalTheme';
const buildSx = (style, stylesheet, additionalProps) => {
    const resolvedBgColor = replaceStylesheetGlobals(stylesheet, style.backgroundColor);
    // Only apply backgroundColor if it's not transparent - let parent background show through
    const backgroundColorProp = (resolvedBgColor === 'rgba(0,0,0,0)' || resolvedBgColor === 'transparent')
        ? undefined
        : resolvedBgColor;
    return {
        ...(backgroundColorProp !== undefined && { backgroundColor: backgroundColorProp }),
        borderColor: replaceStylesheetGlobals(stylesheet, style.borderColor),
        borderRadius: `${style.borderRadius}px`,
        borderWidth: style.borderWidth,
        borderStyle: 'solid',
        color: replaceStylesheetGlobals(stylesheet, style.color),
        margin: `${style.margin}px`,
        padding: `${style.padding}px`,
        boxShadow: style.shadow,
        fontSize: style.fontSize ? `${style.fontSize}px` : 'inherit',
        fontFamily: style.fontFamily || 'inherit',
        ...(Number.isFinite(style.lineSpacing) && { lineHeight: `${style.lineSpacing}px` }),
        ...(Number.isFinite(style.paragraphSpacing) && { '--mc-paragraph-spacing': `${style.paragraphSpacing}px` }),
        ...additionalProps,
    };
};
export default buildSx;
//# sourceMappingURL=buildSx.js.map